<template>
  <div id="app">
    <div class="wrapper" :class="visible ? 'openNav' : ''">
      <div class="sidebar" :class="[lv]">
        <div class="clearfix">
          <div class="navBox" id="openSidebar" @click="showNav">
            <a href="javascript:void(0)" class="navOpen"></a>
          </div>
          <div id="menu" class="menu-flex">
            <!-- <div class="logo clogo"></div> -->

            <ul class="clearfix list">
              <li>
                <a href="https://www.shipoe360.com/vr/dist" class="nav_home">
                  <span><i class="icon icon1"></i>首页</span></a
                >
              </li>
              <li class="nav_cate">
                <a href="javascript:void(0)" @click="phoneShowNav"
                  ><span>选型类别</span></a
                >
              </li>
              <li>
                <a
                  href="https://www.shipoe360.com/test/index.html"
                  class="nav_services"
                  ><span><i class="icon icon2"></i>关于我们</span></a
                >
              </li>
              <li>
                <a
                  href="https://www.shipoe360.com/test/join.html"
                  class="nav_case"
                  ><span><i class="icon icon3"></i>加入我们</span></a
                >
              </li>
              <li>
                <a href="https://www.shipoe360.com/#/vradress" class="nav_case"
                  ><span><i class="icon icon4"></i>船企定位</span></a
                >
              </li>
              <li>
                <a
                  href="https://www.shipoe360.com/#/VrshipchartLibrarydetails
"
                  class="nav_about"
                  ><span><i class="icon icon5"></i>船型类别</span></a
                >
              </li>
              <li>
                <a
                  href="https://www.shipoe360.com/#/Vrmembershipactivitiesdetails
"
                  class="nav_news"
                  ><span><i class="icon icon6"></i>活动动态</span></a
                >
              </li>
              <li>
                <a
                  href="https://www.shipoe360.com/test/contact.html"
                  class="nav_contact"
                  ><span> <i class="icon icon7"></i>意见反馈</span></a
                >
              </li>
            </ul>
            <ul class="clearfix list cate_list" v-show="visible && showCateNav">
              <li
                v-for="(item, index) in list"
                :key="index"
                @click="l1Mouseenter(index)"
              >
                <a href="javascript:void(0)" class="nav_home"
                  ><span>{{ item.name }}</span></a
                >
              </li>
            </ul>
            <ul
              class="clearfix list cate_list"
              v-show="l2List.length > 0 && visible && showCateNav"
            >
              <li
                v-for="(item, index) in l2List"
                :key="index"
                @click="l2Mouseenter(index)"
              >
                <a href="javascript:void(0)" class="nav_home"
                  ><span>{{ item.name }}</span></a
                >
              </li>
            </ul>
            <ul
              class="clearfix list cate_list"
              v-show="
                l3List.length > 0 && l2List.length > 0 && visible && showCateNav
              "
            >
              <li
                v-for="(item, index) in l3List"
                :key="index"
                @click="getVrUrl(index)"
              >
                <a href="javascript:void(0)" class="nav_home"
                  ><span>{{ item.title }}</span></a
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="pageMain">
        <div id="header">
          <!-- <div class="k1120 clearfix">
            <a href="#" id="logo" class="logo">logo</a>
          </div> -->
          <div class="l-bar">
            <span class="back" @click="back">返回</span>
          </div>
        </div>
        <div class="nav-list" @mouseleave="Mouseleave('all')">
          <div class="title"><i class="icon icon1" />选型类别</div>
          <ul class="clearfix l1" ref="l1">
            <li
              v-for="(item, index) in list"
              :key="index"
              @mouseenter="l1Mouseenter(index)"
              @mouseleave="l1Mouseleave"
            >
              <a
                href="javascript:void(0)"
                :class="l1 === index ? 'active' : ''"
              >
                <span>{{ item.name }}</span>
              </a>
            </li>
          </ul>
          <ul
            class="child l2"
            ref="l2"
            @mouseenter="Mouseenter('l2')"
            @mouseleave="Mouseleave('l2')"
            v-show="l2List.length > 0"
          >
            <li
              v-for="(c_item, index) in l2List"
              :key="c_item.id"
              @mouseenter="l2Mouseenter(index)"
              @mouseleave="l2Mouseleave"
            >
              <a
                href="javascript:void(0)"
                :class="l2 === index ? 'active' : ''"
              >
                <span>{{ c_item.name }}</span>
              </a>
            </li>
          </ul>
          <ul
            class="child l3"
            ref="l3"
            @mouseenter="Mouseenter('l3')"
            @mouseleave="Mouseleave('l3')"
            v-show="l3List.length > 0"
          >
            <li
              v-for="(c_item, index) in l3List"
              :key="c_item.id"
              @click="getVrUrl(index)"
            >
              <a href="javascript:void(0)">
                <span>{{ c_item.title }}</span>
              </a>
            </li>
          </ul>
        </div>
        <div class="box">
          <div
            class="bg"
            v-if="!!!iframeUrl"
            :style="`background-image: url(${bgUrl}});background-size: 100% 100%;`"
          ></div>
          <iframe
            v-if="!!iframeUrl"
            ref="iframe"
            id="iframe"
            :src="iframeUrl"
            style="width: 100vw; height: 100%"
          ></iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let l1timer = null;
let l2timer = null;
export default {
  name: "App",
  components: {},
  data() {
    return {
      visible: false,
      showCateNav: false,
      bgUrl:
        "https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fup.enterdesk.com%2Fphoto%2F2009-4-13%2F200904112337297068.jpg&refer=http%3A%2F%2Fup.enterdesk.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1670032994&t=66c0df18e5c12a02f4ae3dd044411d73",
      // https://www.expoon.com/e/tzlf5tmvpx7/
      iframeUrl: "https://www.expoon.com/e/yee5vvt15v0/panorama/223632",
      preUrl: "",
      // iframeUrl: "https://www.expoon.com/e/yee5vvt15v0/",
      list: [],
      l2List: [],
      l3List: [],
      l1: -1,
      l2: -1,
      move2: false,
      move3: false,
    };
  },
  created() {
    fetch("https://admin.shipoe360.com/api/picture/all_type")
      .then((res) => res.json())
      .then((res) => {
        this.list = res.data.list;
        // this.l2List = (res.data.list[0] || {}).child || [];
        // this.l3List = this.l2List[0].child_2;
      });
  },
  mounted() {},
  computed: {
    lv() {
      if (this.visible) {
        if (
          this.showCateNav &&
          this.l2List.length > 0 &&
          this.l3List.length > 0
        )
          return "le3";
        if (this.showCateNav && this.l2List.length > 0) return "le2";
        if (this.showCateNav) return "le1";
      }
      return "";
    },
  },
  methods: {
    l1Mouseenter(index) {
      l1timer && clearTimeout(l1timer);
      this.l1 = index;
      this.l2List = (this.list[index] || {}).child || [];
      this.l3List = [];
    },
    l1Mouseleave() {
      l1timer && clearTimeout(l1timer);
      l1timer = setTimeout(() => {
        if (!this.move2) {
          this.l1 = -1;
          this.l2List = [];
        }
      }, 200);
    },

    l2Mouseenter(index) {
      l2timer && clearTimeout(l2timer);
      this.l3List = (this.l2List[index] || {}).child_2 || [];
      this.l2 = index;
    },
    l2Mouseleave() {
      l2timer && clearTimeout(l2timer);
      l2timer = setTimeout(() => {
        if (!this.move3) {
          this.l2 = -1;
          this.l3List = [];
        }
      }, 200);
    },
    Mouseenter(lv) {
      if (lv === "l2") {
        this.move2 = true;
      }
      if (lv === "l3") {
        this.move3 = true;
      }
    },
    Mouseleave(lv) {
      if (lv === "all") {
        this.l2List = [];
        this.l3List = [];
        this.move2 = false;
        this.move3 = false;
        this.l1 = -1;
        this.l2 = -1;
      }
      if (lv === "l2") {
        if (!this.move3) {
          this.move2 = false;
        }
      }
      if (lv === "l3") {
        this.move3 = false;
        this.l2Mouseleave();
      }
    },
    showNav() {
      this.visible = !this.visible;
      this.showCateNav = false;
      this.l2List = [];
      this.l3List = [];
    },
    back() {
      this.iframeUrl = this.preUrl;
    },
    getVrUrl(index) {
      this.preUrl = this.iframeUrl;
      this.iframeUrl = this.l3List[index].vrlink || "";
      this.visible = false;
      this.showCateNav = false;
      this.l2List = [];
      this.l3List = [];
      this.l2 = -1;
      this.l1 = -1;
    },
    phoneShowNav() {
      this.showCateNav = !this.showCateNav;
    },
    isPhone() {
      const userAgentInfo = navigator.userAgent;
      const Agents = [
        "Android",
        "iPhone",
        "SymbianOS",
        "Windows Phone",
        "iPad",
        "iPod",
      ];
      let flag = true;
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
        }
      }
      return !flag;
    },
  },
};
</script>

<style></style>
